import React from 'react';
import { PageHero } from '../components/PageHero';
import { Procurement } from '../components/Procurement';
export function ProcurementPage() {
  return <>
      <PageHero breadcrumb="Procurement" title="Procurement" subtitle="Transparent, fair, and accountable procurement of goods, works, and services for the continent." data-id="element-339" />
      <Procurement data-id="element-340" />
    </>;
}